module.exports = __webpack_public_path__ + "img/50_photo.b7de2fc9.png";